import React, { Component } from 'react';
import MUIDataTable from 'mui-datatables';
import { Link } from 'react-router-dom';
import Services from '../../services/service';
import moment from 'moment';
import 'moment/locale/id';
import DatePicker from 'react-datepicker';
import { Panel } from '../../components/panel/panel';
import { Card, CardBody } from 'reactstrap';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {getMuiTheme, tableOptions} from '../../util/MuiTableTheme';

class SummaryAttendance extends Component {

  constructor(props){
    super(props);
    this.state = {
      modalAdd: false,
      dataAbsensi: [],
      date: moment().format('DD-MM-YYYY'),
      detailDate: ''
    };
  }

  componentDidMount() {
    this.getAbsensi();
  }

  _renderDatePicker = () => (
    <DatePicker
      className='form-control'
      value={this.state.date}
      placeholderText="Click to select a date"
      onChange={this._handleDateChange}
      onCalendarClose={this._handleCalendarClose}
      // onCalendarOpen={this._handleCalendarOpen}
    />
  );

  _handleDateChange = value => {
    this.setState({
      detailDate: moment(value).locale('id').format('DD MMMM YYYY'),
      date: moment(value).format('DD-MM-YYYY')
    });
  };

  _handleCalendarClose = () => {
    this.getAbsensi();
  };

  getAbsensi = () => {
    Services.getAbsensi({date: this.state.date})
      .then(res => {
        this.setState({dataAbsensi: res.data});
      })
      .catch(err => console.log(err))
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Kehadiran Pegawai</li>
      </ol>
      <h1 className="page-header">Laporan Kehadiran Pegawai</h1>
    </div>
  );
  
  renderFilterDateSection = () =>(
    <Card
      className="border-0 card-inverse text-white bg-dark"
      style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
    >
      <CardBody>
        <div className="w-100 customDatePickerWidth">
          <label className="mr-2">Tanggal</label>
          {this._renderDatePicker()}
        </div>
      </CardBody>
    </Card>
  );

  renderTableAttendance = () => {
    const { dataAbsensi, date, detailDate } = this.state;
    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "nip",
        label: "NIP",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "user",
        label: "User",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "position",
        label: "Jabatan",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "phone",
        label: "No Telp",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "gender",
        label: "Gender",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "start_time",
        label: "Jam Masuk",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment(value).format('DD-MM-YYYY')
        }
      },
      {
        name: "end_time",
        label: "Jam Keluar",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "count_time",
        label: "Total Jam",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Aksi",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px", maxWidth: "200px" }}),
          customBodyRender: (value, tableMeta) => {
            return (
              <div className="with-btn text-nowrap">
                <Link
                  to={{
                    pathname: "/reporting/summary-attendance-detail",
                    state: {
                      date: date,
                      detailDate: detailDate,
                      dataAbsensi: dataAbsensi[tableMeta.rowIndex]
                    },
                  }}
                  className="btn btn-sm btn-primary width-60 m-r-2"
                >Detail</Link>
              </div>
            );
          }
        }
      }
    ];

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List Kehadiran Pegawai"}
          data={dataAbsensi}
          columns={columns}
          options={tableOptions}
        />
      </MuiThemeProvider>
    )
  };

  render() {
    return (
      <div>
        {this.renderBreadcrumb()}
        <Panel>
          {this.renderFilterDateSection()}
          {this.renderTableAttendance()}
        </Panel>
      </div>
    )
  }
}

export default SummaryAttendance;
